import LoadingIndicator from 'components/shared/LoadingIndicator';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetConsentformDataQuery } from "store/services/utility";
import parse from "html-react-parser";
import { genericFormErrorMsg } from 'utils/validation/validationHelpers';

const CompleteFormsFill = () => {
    const { parent_id, consent_id } = useParams();
    const navigate = useNavigate();

    const { data, error, isLoading } = useGetConsentformDataQuery({ parent_id, consent_id });
    const [errorMessage, setErrorMessage] = useState(null);

    // Handle error state
    if (error) {
        return <div className="error-message">{genericFormErrorMsg}</div>;
    }

    // Handle loading state
    if (isLoading) {
        return <LoadingIndicator />;
    }

    // Check if data is available
    if (!data || !data.formAssigned) {
        return <div>No form data available.</div>;
    }

    // Get the submitted values
    const submittedValues = JSON.parse(data.submission || "{}"); // Parse the submission JSON
    const parsedHtml = data.formAssigned.consent_form?.replace(/{{(.*?)}}/g, (_, key) => {
        const value = submittedValues[key.trim()]; // Get the value from submittedValues

        // Handle gender specifically
        if (key.trim() === "gender") {
            return `
                <input type='radio' value='male' class='consent-form-input' name='gender' ${value === "male" ? "checked" : ""} disabled />
                <input type='radio' value='female' class='consent-form-input' name='gender' ${value === "female" ? "checked" : ""} disabled />
            `;
        }

        // Handle date of birth and other text inputs
        return `<input type='${key.trim() === "dob" || key.trim() === "date" ? "date" : "text"}' class='consent-form-input' name='${key.trim()}' value='${value || ""}' disabled />`;
    });

    return (
        <div className='consent-form-wrapper'>
            <div className='pt-4 text-center'>
                <h5 className="m-0 fw-bold themeBlue pb-2 text-capitalize">{data.formAssigned.title || "--"}</h5>
                <h6 className="m-0 fw-bold pb-4" style={{ color: "#B46C9F" }}>( *Information Must Be Complete )</h6>
            </div>

            <div className='p-4' style={{ backgroundColor: "#F9F9F9" }}>
                <pre>{parse(parsedHtml || "")}</pre>
            </div>
        </div>
    );
}

export default CompleteFormsFill;